(function() {
  'use strict';

  angular
    .module('qbePortal.routes')
    .run($run);


  $run.$inject = ['$rootScope', '$state' , '$stateParams', 'Util', 'storage', 'MODULE_INFO'];

  /**
  * track virtual page views for all page.
  */
  function $run($rootScope, $state, $stateParams, util, storage, MODULE_INFO) {


    $rootScope.$on('$stateChangeSuccess', function() {
      var completed = typeof(storage.getItem('completed-step')) === 'string' ? storage.getItem('completed-step') : null ;
      var fromRapidEstimate = typeof(storage.getItem('ignoreRapidEstimateRoute')) === 'string' ? true : false;
	  var isRetrieval = storage.getItem('retrieve');
      util.dispatchCustomEvent('route-changed' , {current: $state.current, completed: completed});


     /** clean up storage on the first load of the first route
      * it's important this does not run when user comes back to
      * the first route through back or progress bar.
      */
      if ( !completed && !isRetrieval
           && $state.current.name == MODULE_INFO.startRouteName
           && ! fromRapidEstimate
           ) {
         storage.clear();
      }

      storage.removeItem('ignoreRapidEstimateRoute');
    });

    window.addEventListener('route-disallowed', function (e) {
       var redirect = e.detail.redirect || MODULE_INFO.startRouteName ;
       $state.go(redirect);
    });

     window.addEventListener('cross-route-disallowed', function (e) {
       var redirect = MODULE_INFO.startRouteName ;
       storage.clear();
       $state.go(redirect);
    });

  }
})(angular);
